import { useEffect, useState } from "react";
import { Bot, ChevronDown } from "lucide-react";
import { http, tname } from "@/lib/api";

const HERO = "https://static.prod-images.emergentagent.com/jobs/819a2246-98fb-409c-b098-c7d49ac00997/images/fa18239f32239a0bebc0e22ccee01f899b4848f2624507f7793893d82d837c39.jpeg";

function Ticker() {
  const [items, setItems] = useState([]);
  useEffect(() => { http.get("/public/feed").then((r) => setItems(r.data.upcoming.slice(0, 24))).catch(() => {}); }, []);
  if (!items.length) return null;
  const row = items.map((i) => (
    <span key={i.match_id} className="inline-flex items-center gap-2 px-6 text-sm">
      <img src={i.match.homeTeam.crest} alt="" className="w-5 h-5 object-contain" />
      <b>{tname(i.match.homeTeam)}</b><span className="text-slate-500">vs</span><b>{tname(i.match.awayTeam)}</b>
      <img src={i.match.awayTeam.crest} alt="" className="w-5 h-5 object-contain" />
      {i.prediction && <span className="ml-1 px-2 py-0.5 rounded bg-[var(--gold)] text-slate-950 font-display font-bold">{i.prediction.data.esito}</span>}
      <span className="text-slate-600 pl-4">●</span>
    </span>
  ));
  return (
    <div data-testid="hero-ticker" className="absolute bottom-0 inset-x-0 bg-slate-950/70 backdrop-blur-md border-t border-white/10 overflow-hidden py-3">
      <div className="ticker-track whitespace-nowrap">{row}{row}</div>
    </div>
  );
}

export default function Hero({ name, tg, onExplore }) {
  return (
    <section data-testid="public-hero" className="hero relative overflow-hidden rounded-2xl border border-slate-800 min-h-[520px] sm:min-h-[600px]">
      <img src={HERO} alt="Stadio di calcio di notte" className="hero-img absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0F1D] via-[#0A0F1D]/75 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1D] via-transparent to-transparent" />
      <div className="hero-beam hero-beam-1" />
      <div className="hero-beam hero-beam-2" />

      <div className="relative z-10 p-7 sm:p-14 max-w-3xl">
        <span className="inline-flex items-center gap-2 rounded-full border border-[var(--gold)]/40 bg-[var(--gold)]/10 px-3 py-1 font-mono text-[11px] text-[var(--gold)] tracking-widest hero-rise" style={{ animationDelay: "0ms" }}>
          <span className="w-2 h-2 rounded-full bg-[var(--gold)] animate-pulse" /> LIVE · STAGIONE 2026/27
        </span>
        <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl font-extrabold uppercase leading-[0.85] mt-5 hero-rise" style={{ animationDelay: "120ms" }}>
          Il calcio<br />letto dall'<span className="text-[var(--gold)]">AI</span>
        </h1>
        <p className="text-slate-300 text-base sm:text-lg mt-5 max-w-xl hero-rise" style={{ animationDelay: "240ms" }}>
          Pronostici, risultati e classifiche di 12 competizioni: dalla Serie A alla Champions League.
        </p>
        <div className="flex flex-wrap gap-3 mt-8 hero-rise" style={{ animationDelay: "360ms" }}>
          <button data-testid="hero-explore-btn" onClick={onExplore} className="btn btn-gold px-5 py-3">Vedi i pronostici <ChevronDown size={16} /></button>
          <a data-testid="hero-telegram-btn" href={tg} target="_blank" rel="noreferrer" className="btn btn-tg px-5 py-3"><Bot size={16} /> {name ? "Entra nel bot" : "Telegram"}</a>
        </div>
      </div>
      <Ticker />
    </section>
  );
}
